<template lang='pug'>
div
  v-row(no-gutters style='display: flex; justify-content: flex-end')
    v-col(cols='auto' v-if='visibleSelect && dashboard && isShowMenu')
        v-select(
          v-model='select',
          :close-on-content-click='false',
          :hint='`${select.key}`',
          :items='items'
          item-text='key'
          item-value='value'
          label='Select'
          persistent-hint
          return-object
          single-line
          style='margin-right: 5%')
    v-col(cols='auto')
      v-menu(
        v-model='menu1',
        :close-on-content-click='false'
        transition='scale-transition'
        offset-y
        max-width='290px'
        min-width='290px')
        template(v-slot:activator='{ on, attrs }')
          v-text-field(
            v-model='computedDate1Formatted',
            :error='error1',
            :label='$t("dateInterval.startDate")'
            v-mask='fieldMask'
            :hint='getDefaultFormat'
            persistent-hint
            prepend-icon='event'
            v-bind='attrs'
            v-on='on')
        v-date-picker(
          v-if='panel1 === "date"'
          v-model='dInterval.d1',
          :max='dInterval.d2'
          :locale='checkDefaultLanguage()'
          color='#9c27b0'
          @input='inputPanel("1", "date")')
        v-time-picker(
          v-if='panel1 === "time"'
          v-model='dInterval.t1'
          flat
          format='24hr',
          :max='dInterval.d1 === dInterval.d2 ? dInterval.t2 : null'
          @click:minute='written1 = false; error1 = false'
          color='#9c27b0'
          scrollable)
          div(style='flex-grow: 1 !important')
          v-btn(text color='#1867c0' @click='panel1 = "date"') {{ $t("dateInterval.toGoBack") }}
          v-btn(text color='#1867c0' @click='inputPanel("1", "time")') OK
    v-col(cols='auto' style='align-self: center; margin: 0 9px')
      | {{ $t("dateInterval.upUntil") }}
    v-col(cols='auto')
      v-menu(
        v-model='menu2',
        :close-on-content-click='false'
        transition='scale-transition'
        offset-y
        max-width='290px'
        min-width='290px')
        template(v-slot:activator='{ on, attrs }')
          v-text-field#field2(
            v-model='computedDate2Formatted',
            :error='error2',
            :label='$t("dateInterval.endDate")'
            v-mask='fieldMask'
            :hint='getDefaultFormat'
            persistent-hint
            prepend-icon='event'
            v-bind='attrs'
            v-on='on')
        v-date-picker(
          v-if='panel2 === "date"'
          v-model='dInterval.d2',
          :min='dInterval.d1',
          :max='maxDateToday'
          :locale='checkDefaultLanguage()'
          color='#9c27b0'
          @input='inputPanel("2", "date")')
        v-time-picker(
          v-if='panel2 === "time"'
          v-model='dInterval.t2'
          flat
          format='24hr',
          :min='dInterval.d1 === dInterval.d2 ? dInterval.t1 : null'
          @click:minute='written2 = false; error2 = false'
          color='#9c27b0'
          scrollable)
          div(style='flex-grow: 1 !important')
          v-btn(text color='#1867c0' @click='panel2 = "date"') Voltar
          v-btn(text color='#1867c0' @click='inputPanel("2", "time")') OK
    v-col(cols='auto' style='align-self: center; margin-left: 9px')
      md-button.md-info(
        @click='send()'
        style='float: right; background-color: #26c6da !important; margin-top: 16px')
        md-icon search
        //- img(:src='icons.createUser' style='height: 26px; width: 26px; margin-right: 10px;')
</template>

<script>
import { mask } from 'vue-the-mask'
import DataProvider from '@/components/DataProvider'
import Swal from 'sweetalert2'
import moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'

export default {
  components: {
    DataProvider
  },
  directives: { mask },
  model: {
    prop: 'dateObjInterval',
    event: 'update'
  },
  props: {
    isShowMenu: {
      type: Boolean,
      default: true
    },
    visibleSelect: {
      type: [Boolean, Function],
      default: false
    },
    dashboard: {
      type: Boolean,
      default: false
    },
    dateObjInterval: {
      type: Object,
      default: () => ({
        timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm'),
        timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm'),
        select: { key: this.$t('dateInterval.general'), value: 'all' },
        menu: { key: this.$t('dateInterval.all'), value: 'all' },
        subMenu: { key: this.$t('dateInterval.all'), value: 'all' }
      })
    },
    max30: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cumputedSelect: {
      get: () => ({ key: this.$t('dateInterval.general'), value: 'all' }),
      set: (nV) => (this.select = nV)
    },
    computedDate1Formatted: {
      get: function () {
        return `${this.formatDate(this.dInterval.d1)} - ${
          this.dInterval.t1 === null ? '00:00' : this.dInterval.t1
        }`
      },
      set: function (nV) {
        this.written1 = nV
      }
    },
    computedDate2Formatted: {
      get: function () {
        return `${this.formatDate(this.dInterval.d2)} - ${
          this.dInterval.t2 === null ? '23:59' : this.dInterval.t2
        }`
      },
      set: function (nV) {
        this.written2 = nV
      }
    },
    maxDateToday () {
      return new Date().toISOString().substr(0, 10)
    },
    getDefaultFormat () {
      const formatDate = moment().locale(selectedLocale).localeData().longDateFormat('L')
      return `${this.$t('dateInterval.format')}: ${formatDate} HH:MM`
    }
  },
  watch: {
    menu1 (nV) {
      if (!nV) {
        this.onClose1()
      }
    },
    menu2 (nV) {
      if (!nV) {
        this.onClose2()
      }
    },
    dateObjInterval: {
      deep: true,
      immediate: true,
      handler (nV) {
        const date1 = nV.timestamp1.split('T')
        const date2 = nV.timestamp2.split('T')

        const [hours1, minutes1] = date1[1].split(':')
        const [hours2, minutes2] = date2[1].split(':')

        this.dInterval = {
          d1: date1[0],
          d2: date2[0],
          t1: moment().set({ hours: hours1, minutes: minutes1, seconds: 0 }).format('HH:mm'),
          t2: moment().set({ hours: hours2, minutes: minutes2, seconds: 59 }).format('HH:mm')
        }
      }
    }
  },
  data () {
    return {
      dInterval: {},
      menu1: false,
      menu2: false,
      panel1: 'date',
      panel2: 'date',
      fieldMask: '##/##/#### - ##:##',
      written1: false,
      written2: false,
      error1: false,
      error2: false,
      select: { key: this.$t('dateInterval.general'), value: 'all' },
      items: [
        { key: this.$t('dateInterval.general'), value: 'all' },
        {
          key: this.$t('dateInterval.authenticatedArea'),
          value: 'authenticated'
        },
        { key: this.$t('dateInterval.publicArea'), value: 'no_authenticated' }
      ]
    }
  },
  methods: {
    loadLocaleMessages () {
      const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
      const validations = require.context('vee-validate/dist/locale', true, /[A-Za-z0-9-_,\s]+\.json$/i)
      const messages = {}
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
          const locale = matched[1]
          messages[locale] = locales(key)
          const validationsKey = key.replace(/-/g, '_')
          messages[locale].validations = validations(validationsKey).messages
        }
      })
      return messages
    },
    checkDefaultLanguage () {
      let matched = null
      let languages = Object.getOwnPropertyNames(this.loadLocaleMessages())
      languages.forEach((lang) => {
        if (lang === navigator.language) {
          matched = lang
        }
      })
      if (!matched) {
        languages.forEach((lang) => {
          let languagePartials = navigator.language.split('-')[0]
          if (lang === languagePartials) {
            matched = lang
          }
        })
      }
      if (!matched) {
        languages.forEach((lang) => {
          let languagePartials = navigator.language.split('-')[0]
          if (lang.split('-')[0] === languagePartials) {
            matched = lang
          }
        })
      }
      return matched
    },
    send () {
      let valid = true
      this.error1 = false
      this.error2 = false
      // Check if isWritten is a String or false. If false, it means the field was not filled by the user
      let isWritten1 = typeof this.written1 === 'string'
      let isWritten2 = typeof this.written2 === 'string'
      // If it is written by the user, we have to validate everything
      // If the user hasn't written, date1/2 is d1/2, otherwise it's the value written
      // We have to convert the value written dd/mm/yyyy to ISO yyyy/mm/dd
      let date1, date2
      if (isWritten1) {
        const [day1, month1, year1] = this.written1.substr(0, 10).split('/')
        date1 = `${year1}-${month1}-${day1}`
      } else {
        date1 = this.dInterval.d1
      }
      if (isWritten2) {
        const [day2, month2, year2] = this.written2.substr(0, 10).split('/')
        date2 = `${year2}-${month2}-${day2}`
      } else {
        date2 = this.dInterval.d2
      }

      // If the user hasn't written or selected a time, by default it's 00:00 and 23:59
      let time1 = isWritten1
        ? this.written1.substr(13, 5) || '00:00'
        : this.dInterval.t1 || '00:00'
      let time2 = isWritten2
        ? this.written2.substr(13, 5) || '23:59'
        : this.dInterval.t2 || '23:59'
      // If any of the isWritten is true, we need to re-evaluate the range/format conditions
      if (
        typeof this.written1 === 'string' ||
        typeof this.written2 === 'string'
      ) {
        valid = this.validateFields(date1, time1, date2, time2)
      }
      // If it's valid we need to update the data
      if (valid) {
        this.updateInterval(date1, time1, date2, time2)
      } else {
        Swal.fire({
          title: this.$t('dateInterval.invalidTimeRange'),
          buttonsStyling: false,
          icon: 'error',
          confirmButtonClass: 'md-button md-danger'
        })
      }
    },
    updateInterval (date1, time1, date2, time2) {
      this.dInterval.d1 = date1
      this.dInterval.d2 = date2
      this.dInterval.t1 = time1
      this.dInterval.t2 = time2
      const dateInterval = {
        timestamp1: moment(`${date1} ${time1}`).seconds(0).format(),
        timestamp2: moment(`${date2} ${time2}`).seconds(59).format()
      }
      this.$emit('update', dateInterval)
    },
    validateFields (date1, time1, date2, time2) {
      // Check dates for leap years etc
      this.error1 = !this.validateDate(date1)
      if (this.error1) return false
      this.error2 = !this.validateDate(date2)
      if (this.error2) return false
      // Check if days's range are valid and check time
      // Create Date Objects for comparisons
      let dateObj1 = new Date(date1)
      let dateObj2 = new Date(date2)
      if (!this.validateTime(time1, time2)) return false
      if (dateObj1 > dateObj2) {
        this.error1 = true
        this.error2 = true
        return false
      } else if (
        dateObj1.setHours(0, 0, 0, 0) === dateObj2.setHours(0, 0, 0, 0)
      ) {
        let timeNumber1 = parseInt(time1.replace(':', ''))
        let timeNumber2 = parseInt(time2.replace(':', ''))
        if (timeNumber1 > timeNumber2) {
          this.error2 = true
          return false
        }
      }
      return true
    },
    changeSubMenu (event) {
      this.showSubMenu = true
      const first = this.subMenuList[0]
      this.subMenuList = event.subMenu
      this.subMenuList.unshift(first)
    },
    validateDate (dateString) {
      const date = moment(dateString, 'DD/MM/YYYY')
      return date.isValid()
    },
    validateTime (time1, time2) {
      // Validate time, can't be greater than 2359 and less than 4 in length
      let hourNumber1 = parseInt(time1.split(':')[0])
      let minuteNumber1 = parseInt(time1.split(':')[1])
      let hourNumber2 = parseInt(time2.split(':')[0])
      let minuteNumber2 = parseInt(time2.split(':')[1])
      if (time1.length < 5 || hourNumber1 > 23 || minuteNumber1 > 59) {
        this.error1 = true
        return false
      }
      if (time2.length < 5 || hourNumber2 > 23 || minuteNumber2 > 59) {
        this.error2 = true
        return false
      }
      return true
    },
    formatDate (date) {
      if (!date) return null
      return moment(date).locale(selectedLocale).format('L')
    },
    onClose1 () {
      this.menu1 = false
      this.panel1 = 'date'
    },
    onClose2 () {
      this.menu2 = false
      this.panel2 = 'date'
    },
    inputPanel (field, panel) {
      if (field === '1') {
        if (panel === 'date') {
          this.panel1 = 'time'
          this.dInterval.t2 = null
        }
        if (panel === 'time') {
          this.error1 = false
          this.written1 = false
          this.onClose1()
        }
      } else if (field === '2') {
        if (panel === 'date') {
          this.panel2 = 'time'
          // this.dInterval.d1 = this.dInterval.d2
        }
        if (panel === 'time') {
          this.error2 = false
          this.written2 = false
          this.onClose2()
        }
      }
    },
    mountDateTime (d, t, seconds) {
      return moment.utc(`${d}T${t}:${seconds}`).format('YYYY-MM-DD[T]HH:mm:ss')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    }
  }
}
</script>

<style>
.v-input__append-outer,
.v-input__prepend-outer {
  margin-right: 9px !important;
}
.primary--text {
  color: #9c27b0 !important;
  caret-color: #9c27b0 !important;
}
.v-btn--icon.v-size--default .v-icon {
  height: 24px !important;
  font-size: 14px !important;
  width: 24px !important;
}
.v-btn--icon.v-size--default {
  height: 36px !important;
  width: 36px !important;
}
.theme--light.v-btn.v-btn--icon {
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-time-picker-clock__ampm
  > .v-picker__title__btn.v-picker__title__btn--active {
  font-weight: 600;
}
</style>
